import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ServerService} from '../service/server.service';
import {AlertController, LoadingController, ModalController, NavController, ToastController} from '@ionic/angular';
import {SocialSharing} from '@awesome-cordova-plugins/social-sharing/ngx';
import {AuthService} from '../service/auth.service';
import {Constant} from '../shared/model/Constant';
import {AdminService} from "../service/admin.service";
import {NgForm} from "@angular/forms";


@Component({
  selector: 'app-setting',
  templateUrl: './setting.page.html',
  styleUrls: ['./setting.page.scss'],
})

export class SettingPage implements OnInit {
  @ViewChild('form', {static: false}) ngForm: NgForm;
  data: any;
  text: any;
  color: any;
  heading: any;
  show = true;
  primaryColor: any;
  secondaryColor: any;
  user: any;
  previousStyles: any;
  userId: string;
  loading: any;
  private fileType: any;
  fileUrl: any;

  constructor(private socialSharing: SocialSharing,
              public alertController: AlertController,
              private route: ActivatedRoute,
              public server: ServerService,
              public toastController: ToastController,
              private nav: NavController,
              public loadingController: LoadingController,
              private userService: AuthService,
              private adminService: AdminService,
              public modalController: ModalController,
              private authService: AuthService,) {


    this.userId = localStorage.getItem(Constant.userId);
    this.data = JSON.parse(localStorage.getItem(Constant.userData));
    this.text = JSON.parse(localStorage.getItem(Constant.appText));
    this.user = JSON.parse(localStorage.getItem(Constant.userData1));

  }

  async ngOnInit() {
    this.loading = await this.loadingController.create({
      message: '',
      spinner: 'bubbles',
      duration: 30000
    });
    this.getStyles();
  }


  async save(data) {
    const loading = await this.loadingController.create({
      message: '',
      spinner: 'bubbles',
      duration: 3000
    });
    await loading.present();
    const body = {
      primary: this.primaryColor,
      secondary: this.secondaryColor,
      userId: this.userId
    };

    if (!this.previousStyles) {
      this.userService.createStyle(this.userId, body).subscribe(value => {
        loading.dismiss();
        this.presentToast('Colores guardados con éxito');
        this.setStyle();
      });
    } else {
      this.userService.updateStyle(this.userId, body).subscribe(value => {
        loading.dismiss();
        this.presentToast('Colores actualizados con éxito');
        this.setStyle();
      });
    }
  }

  async presentToast(txt) {
    const toast = await this.toastController.create({
      message: txt,
      duration: 3000,
      position: 'top',
      mode: 'ios',
      color: 'dark'
    });
    toast.present();
  }

  setStyle() {
    document.documentElement.style.setProperty('--ion-color-primary', this.primaryColor);
    document.documentElement.style.setProperty('--ion-color-secondary', this.secondaryColor);
  }


  changeColor(event: any) {
    if (event.type === 'primary') {
      this.primaryColor = event.color;
    }
    if (event.type === 'secondary') {
      this.secondaryColor = event.color;
    }
  }

  getStyles() {
    const userId = localStorage.getItem(Constant.userId);
    this.userService.getStyles(userId).subscribe((data) => {
      this.previousStyles = data[0];
      this.primaryColor = this.previousStyles.primary;
      this.secondaryColor = this.previousStyles.secondary;
      this.fileUrl = data[0].logo;
    }, error => {
      console.warn(error);
    });
  }


  uploadLogo(event: any) {
    this.loading.present();
    if (event.target.files[0]) {
      this.fileType = event.target.files[0].type;
      console.log(event.target.files[0]);
      this.adminService.uploadFile(event.target.files[0], 'logos').subscribe((res: any) => {
        this.fileUrl = res.url;
        if (this.fileUrl && this.previousStyles) {
          this.userService.updateStyle(this.userId, {logo: this.fileUrl}).subscribe(value => {
            this.loading.dismiss();
            this.presentToast('Logo Agregado Exitosamente');
            this.setStyle();
          });
        } else {
          this.loading.dismiss();
        }
      }, error => {
        console.warn(error);
        this.loading.dismiss();
      });
    }
  }

  async close(data: any) {
    await this.modalController.dismiss(data);
  }

  async updatePerson(value) {
    const loading = await this.loadingController.create({
      message: '',
      spinner: 'bubbles',
      duration: 3000
    });
    await loading.present();
    await this.loading.present();
    this.authService.updateUser(this.userId, value).subscribe(response => {
      console.log(this.userId, value)
      this.loading.dismiss();
      this.presentToast('Datos básicos usuario fueron actualizados con éxito');
      this.ngForm.reset();
      this.close(true);

    }, error => {
      console.warn('Error al actualizar los datos básicos del usuario', error);
      this.loading.dismiss();
      this.presentToast('Error al actualizar los datos básicos del usuario');
    });
  }

  deleteCache() {
    this.adminService.deleteCache().subscribe(res => {
      this.presentToast('Datos purgados');
    });
  }
}
